module.exports = require('./helpers/bundle-url').getBundleURL('ksUvU') + "1.b50794fe.png" + "?" + Date.now();